/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of game event
 * @export
 */
export const OWGameEventType = {
    KILL: 'KILL',
    ASSIST: 'ASSIST',
    DEATH: 'DEATH',
    DEFEAT: 'DEFEAT',
    MATCH_END: 'MATCH_END',
    MATCH_END_VICTORY: 'MATCH_END_VICTORY',
    MATCH_START: 'MATCH_START',
    HEADSHOT: 'HEADSHOT',
    PLAYTIME: 'PLAYTIME',
    ALLTIME_PLAYTIME: 'ALLTIME_PLAYTIME',
    GOAL: 'GOAL',
    OVERTIME: 'OVERTIME',
    VICTORY: 'VICTORY'
} as const;
export type OWGameEventType = typeof OWGameEventType[keyof typeof OWGameEventType];


export function instanceOfOWGameEventType(value: any): boolean {
    for (const key in OWGameEventType) {
        if (Object.prototype.hasOwnProperty.call(OWGameEventType, key)) {
            if (OWGameEventType[key as keyof typeof OWGameEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OWGameEventTypeFromJSON(json: any): OWGameEventType {
    return OWGameEventTypeFromJSONTyped(json, false);
}

export function OWGameEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameEventType {
    return json as OWGameEventType;
}

export function OWGameEventTypeToJSON(value?: OWGameEventType | null): any {
    return value as any;
}

export function OWGameEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OWGameEventType {
    return value as OWGameEventType;
}

